import { _showAppLogs } from "../LogContext";

export const shouldUseCache = (timestamp_cache, timestamp_db, cache_groupType, timestamp_this) => {
  // If the document was updated *after* the cache, ignore the cache
  if (!timestamp_db || timestamp_db > timestamp_cache) {
    if (_showAppLogs.eventInfo) {
      console.group('Should useCache', cache_groupType)
      console.log(`🚫 Ignore cache data for ${cache_groupType}.`);
      console.log('timestamp_cache', timestamp_cache);
      console.log('timestamp_db', timestamp_db);
      console.log('timestamp_this', timestamp_this)
      console.groupEnd()
    }
    return false; // ignore cache
  }
  _showAppLogs.eventInfo && console.log(`✅ CD ${cache_groupType}!`);
  return true; // cache is still valid
};